<template>
  <div class="loadpage">
    <div v-loading="loading" class="pagess" element-loading-text="页面跳转中..."></div>
  </div>
</template>

<script>
    export default {
        props: {},
        data() {
            return {
                loading: true,
                ruleForm2: {
                    username: "",
                    password: "",
                },
            };
        },
        computed: {},
        created() {
            //window.location.protocol+"//"+window.location.host+'/';
            var token1 = window.location.href.split('token=')[1]
            // var token1 ='AAABcnQdEaQBAAAAAAABiDA%3D.7J1BMzYpkNcvjwX36q2sKIK3rAfAOVaNuxgKYRMIzaQSaUWShNfSvYKii5Mbgg%2BRRJbZFLRyjUMttNr8pWhszXI7csQGlvn3JwEeYqEDfdbM0BSP8tIbpxe2w75MFXowm4uPxtJYVNA4bO1Pt681ZP2KZWjIHoLXgWjJ04ecK5jdgW8uolo9drAKqsSV51e27BD5XoKVHer3H689IT%2BEFmUAYzoWyxf%2BBeq9u7zHLqb4agGl4xHlxKJjFAIDG%2FP6%2Buo2u7wvFLaMeynvagx6%2FOxeLj1QEAr3gfCdLXkhHn6oMYnAYY9YB6b0c95u2BQ%2F.rOE6iVT5H6hd8QRjsSBwYZIb%2FxzjVNmtuZ5ktpjOdcw%3D'
            console.log(token1)
            this.gettoken(token1)
            // console.log(window.location)
            //this.GetQueryString('token')
        },
        methods: {
            //素描提交
            gettoken(token) {
                //   var params = {
                //     'token': token,
                //   }
                this.$http.third_plat(token)
                    .then(res => {
                        if (res.code == 200) {

                            this.ruleForm2.username = res.data.username
                            this.ruleForm2.password = '123456'
                            this.ruleForm2.school_id = '100001'

                            //登录
                            this.loginHandler()
                        } else {
                            this.$message.error(res.message)
                        }

                    })
            },
            GetQueryString(name) {
                // console.log(name)
                // console.log(window.location.search)
                // console.log(window.location)
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");

                var r = window.location.search.substr(1).match(reg);

                if (r != null) {
                    return unescape(r[2]);

                }

                return null;

            },
            loginHandler() {
                let params = {
                    username: this.ruleForm2.username,
                    password: this.ruleForm2.password,
                    school_id: this.ruleForm2.school_id
                };
                this.$http
                    .userLogin(params)
                    .then(res => {
                        if (res.code == 200) {
                            for (let key in res.data) {
                                this.$cookies.set(key, res.data[key]);
                            }
                            this.getUserInfo();
                        } else this.$message.error(res.message);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            checkLogin() {
                if (this.$cookies.get("token")) {
                    this.$router.push({name: "myInfo"});
                }
            },
            getUserInfo() {
                this.$http.getUserInfo().then(res => {
                    // 分发actions中getUserInfo方法  找store/index.js
                    this.$store.dispatch("SetUserInfo", res.data);
                    //返回之前的前面
                    this.$router.push(
                        this.$route.params.redirect
                            ? {path: this.$route.params.redirect}
                            : {name: "practiceList", params: {flag: 1}}
                    );
                });
            },

        },
    };
</script>

<style lang="less">
  .loadpage {
    .ts {
      text-align: center;
    }

    .pagess {
      height: 400px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/assessment/loadingpage.vue